import React from "react";

const GrowthSolutions = () => {
  return (
    <section className="bg-[#D7F3EF] py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">

          {/* LEFT CONTENT */}
          <div>
            {/* Eyebrow */}
            <span className="inline-flex items-center gap-2 text-xs text-[#64748B] border border-[#E2E8F0] bg-white px-3 py-1 rounded-full mb-4">
              Why businesses choose invexflow
            </span>

            {/* Heading */}
            <h2 className="text-2xl md:text-3xl font-semibold text-[#0F172A] mb-6 leading-snug">
              Solutions that accelerate growth
            </h2>

            {/* Bullet points */}
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-6 mb-8 text-sm text-[#475569]">
              <li className="flex gap-2">
                <CheckIcon />
                Unlock cash without diluting equity or adding term debt.
              </li>
              <li className="flex gap-2">
                <CheckIcon />
                Finance selective invoices or entire ledgers on your terms.
              </li>
              <li className="flex gap-2">
                <CheckIcon />
                Protect relationships—your customers keep paying you as usual.
              </li>
              <li className="flex gap-2">
                <CheckIcon />
                Real-time dashboards with clear fees and settlement timelines.
              </li>
            </ul>

            {/* Mini cards */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <MiniCard
                title="Startup runway"
                text="Extend runway by turning receivables into capital for hiring and product."
              />
              <MiniCard
                title="SMB operations"
                text="Improve cash cycles to cover payroll, supplier payments, and growth."
              />
              <MiniCard
                title="Enterprise scale"
                text="Finance large invoices with advanced risk modeling and controls."
              />
            </div>
          </div>

          {/* RIGHT PANEL (Placeholder visual) */}
          <div className="bg-white rounded-2xl h-[260px] md:h-[320px] shadow-sm flex items-center justify-center text-sm text-[#94A3B8]">
            Visual / Dashboard preview
          </div>

        </div>
      </div>
    </section>
  );
};

/* ---------- Subcomponents ---------- */

const MiniCard = ({ title, text }) => (
  <div className="bg-white rounded-xl p-4 border border-[#E2E8F0]">
    <h4 className="text-sm font-semibold text-[#0F172A] mb-1">
      {title}
    </h4>
    <p className="text-xs text-[#64748B] leading-relaxed">
      {text}
    </p>
  </div>
);

const CheckIcon = () => (
  <span className="mt-[2px] flex-shrink-0 w-4 h-4 rounded-full bg-[#00B3A4] text-white flex items-center justify-center text-[10px]">
    ✓
  </span>
);

export default GrowthSolutions;
